import React from 'react';
import Cases from '../components/Cases/Cases';
import Header from '../components/Header/Header';
import { useTranslation } from 'react-i18next';
const CasesPage = () => {
  const { t } = useTranslation();
  return (
    <div className="page-cases" activePage="/cases">
      <Header />
      <div className="page-cases__container container">
        <h2 className="page-cases__title  main-title">
          {t('our_success_stories_title')}
        </h2>
      </div>
      <Cases title={false} />
    </div>
  );
};

export default CasesPage;
